import { useContext, useRef, useState } from 'react';
import { AppContext } from '../util/AppContext';
import { getConfigValue } from '../util/getConfigValue';
import PropType from 'prop-types';
import Tooltip from './Tooltip';

FavoriteFilter.propTypes = {
	hcpFavoriteCheckbox: PropType.bool.isRequired,
	setHcpFavoriteCheckbox: PropType.func.isRequired,
	includeWrappingRow: PropType.bool,
	showTooltipIcon: PropType.bool,
};

export default function FavoriteFilter({ hcpFavoriteCheckbox, setHcpFavoriteCheckbox, includeWrappingRow, showTooltipIcon = false }) {
	const [appState] = useContext(AppContext);
	const hcpFavoritesEnabled = getConfigValue(appState.config?.HCP?.Favorites?.Enabled, appState)?.Value === 'true';
	const preCallPlanningEnabled = getConfigValue(appState.config?.PreCall?.Planning?.Enabled, appState)?.Value === 'true';
	const hcpOpportunityEnabled = getConfigValue(appState.config?.HCP?.Opportunity?.Enabled, appState)?.Value === 'true';
	const filterLabelConfig = preCallPlanningEnabled || hcpOpportunityEnabled
		? appState.config?.Target?.Favorites?.Filter?.Label
		: appState.config?.HCP?.Favorites?.Filter?.Label;
	const filterLabel = getConfigValue(filterLabelConfig, appState)?.Value;
	const filterTooltip = getConfigValue(appState.config?.Target?.SelectHcp?.Filter?.ToolTip?.Label, appState)?.Value;
	const tooltipTarget = useRef(null);
	const [showTooltip, setShowTooltip] = useState(false);

	function handleHcpFavoriteCheckBoxClick(event) {
		setHcpFavoriteCheckbox(event.target.checked);
	}
	const content = (
		<div className='d-flex justify-content-between align-items-center mb-3 mb-md-0 me-md-5'>
			<div className='form-check mb-0'>
				<input
					className='form-check-input'
					type='checkbox'
					id='list-filter-favorites'
					checked={hcpFavoriteCheckbox}
					onChange={(event) => handleHcpFavoriteCheckBoxClick(event)}
				></input>
				<label className='form-check-label type-14' htmlFor='list-filter-favorites'>
					{filterLabel}
				</label>
			</div>
			{showTooltipIcon && (
				<>
					<button type='button' className='btn-reset ms-3'
						onMouseOver={() => setShowTooltip(true)}
						onMouseOut={() => setShowTooltip(false)}
						onFocus={() => setShowTooltip(true)}
						onBlur={() => setShowTooltip(false)}>
						<span ref={tooltipTarget} className='far fa-circle-question type-16 color-primary'></span>
					</button>
					<Tooltip
						text={filterTooltip}
						placement='right'
						ref={tooltipTarget}
						showTooltip={showTooltip}
						index='favorites-filter-tooltip'
						tooltipStyle={{ maxWidth: '420px' }}
					/>
				</>
			)}
		</div>
	);
	return (
		hcpFavoritesEnabled && (
			<>
				{includeWrappingRow && (
					<div className='row my-4'>
						<div className='col-12'>
							<div className='d-flex flex-column flex-md-row justify-content-md-end'>{content}</div>
						</div>
					</div>
				)}
				{!includeWrappingRow && content}
			</>
		)
	);
}
